// src/app/reducers/index.ts
import { ActionReducerMap, MetaReducer } from '@ngrx/store';

import { accountReducer, AccountState } from './account';
import { AgentReducer } from './agent';
import { appReducer, IAppState } from './app';
import { areaReducer } from './area';
import { categoryReducer, CategoryState } from './category';
import { customerReducer, CustomerState } from './customer';
import { projectReducer, ProjectState } from './project';
import { purchaserReducer } from './purchaser';
import { stockReducer } from './stock';
import { supplierReducer } from './supplier';
import { taxReducer, taxState } from './tax';
import { termReducer, TermState } from './term';
import { environment } from '../../environments/environment';
export interface AppState {
  customer: CustomerState;
  project: ProjectState;
  app: IAppState;
  account: AccountState;
  tax: taxState;
  term: TermState;
  category: CategoryState;
  agent: any;
  area: any;
  purchaser: any;
  supplier: any;
  stock: any;
}

export const reducers: ActionReducerMap<AppState> = {
  customer: customerReducer,
  project: projectReducer,
  app: appReducer,
  account: accountReducer,
  tax: taxReducer,
  term: termReducer,
  category: categoryReducer,
  agent: AgentReducer,
  area: areaReducer,
  purchaser: purchaserReducer,
  supplier: supplierReducer,
  stock: stockReducer
};

export const metaReducers: Array<MetaReducer<AppState>> =
  !environment.production ? [] : [];
